import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { InputBase } from './input-base';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent extends InputBase {

  @Input() autocomplete = '';
 
  passwordVisibility = false;

    togglePasswordVisibility() {
    this.passwordVisibility = !this.passwordVisibility;
  }


}
